import { useEffect, useMemo, useState } from "react";
import { Polyline } from "react-leaflet";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";

import usePassages from "Hooks/usePassages";

export default function Passage() {
  const dispatch = useAppDispatch();

  const { visible } = useAppSelector((state) => state.passage);

  const colors = ["#54df33", "#ede140", "#e98a25", "#e93925", "#950505"];

  const { data } = usePassages();

  const renderPolyline = useMemo(() => {
    return data?.map((item: any, index: number) => {
      const route = JSON.parse(`{${item.Map_Data}}`);
      const positions = route?.Location?.split("|")
        .map((point: string) => point?.split(",").map((arr) => Number(arr)))
        .sort(function (a: any, b: any) {
          return b[0] - a[0];
        })
        .map((arr: any) => [arr[1], arr[2]]);

      return (
        <>
          <Polyline
            positions={positions}
            pathOptions={{
              color: colors[Number(route.Status_Id) - 1],
              weight: 4,
            }}
          />
        </>
      );
    });
  }, [visible, data]);

  if (!visible) return <></>;

  return <>{renderPolyline}</>;
}
